import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/axiosConfig";
import endpoints from "../api/endpoints";
import Breadcrumb from "../components/Breadcrumb";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

function CurrentAffairDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    api
      .get(`${endpoints.CURRENT_AFFAIRS}/${id}`)
      .then((res) => {
        if (!cancelled) setArticle(res.data.article || null);
      })
      .catch(() => {
        if (!cancelled) setArticle(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <p className="text-center py-5">Loading current affair...</p>;
  if (!article) return <p className="text-center py-5">Current affair not found.</p>;

  return (
    <>
      <Breadcrumb
        title={article.heading}
        path={
          <>
            <Link to="/current-affairs">Current Affairs</Link> &raquo; {article.heading}
          </>
        }
      />

      <section className="single-blog-section py-120">
        <div className="container">
          <div className="col-lg-8 mx-auto">
            <p className="single-blog-meta">{formatDate(article.date)}</p>
            <h2 className="single-blog-title">{article.heading}</h2>
            <div
              className="single-blog-content"
              dangerouslySetInnerHTML={{ __html: article.text || "" }}
            />
            <Link to="/current-affairs" className="theme-btn-sm">
              Back to list
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default CurrentAffairDetail;
